import { supabaseClient } from 'supabase'

export type QueryDuplicateEventParams = {
  title: string
  title_pt: string
  start_time: Date
  excludeEventId?: number
}

export const queryDuplicateEvent = async ({
  title,
  title_pt,
  start_time,
  excludeEventId
}: QueryDuplicateEventParams) => {
  let query = supabaseClient
    .from('events')
    .select('id, title, title_pt, start_time')

  // Check if either English or Portuguese title matches
  const orConditions = []

  if (title && title.trim()) {
    orConditions.push(`title.eq.${title}`)
    orConditions.push(`title_pt.eq.${title}`)
  }

  if (title_pt && title_pt.trim()) {
    orConditions.push(`title.eq.${title_pt}`)
    orConditions.push(`title_pt.eq.${title_pt}`)
  }

  if (orConditions.length > 0) {
    query = query.or(orConditions.join(','))
  }

  // Match the start time
  query = query.eq('start_time', start_time.toISOString())

  // Exclude current event when updating
  if (excludeEventId !== undefined) {
    query = query.neq('id', excludeEventId)
  }

  const { data, error } = await query

  if (error) {
    throw error
  }

  return data && data.length > 0 ? data[0] : null
}
